
import React, { useState } from "react";
import axios from "axios"; // Import Axios
import { useParams } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import { getCookie } from "./auth/login/GetCookie";

const ReviewModal = ({ show, handleClose, handleSubmit }) => {
    const { id } = useParams();
    const productId = id;
    const [rating, setRating] = useState(0);
    const [comment, setComment] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false); // Track submission state

    // Handle rating selection
    const handleRating = (value) => {
        setRating(value);
    };

    // API call to submit review
    const submitReviewAPI = async (reviewData) => {
        try {
            //const token = localStorage.getItem("token"); // Get the token from localStorage
            const token = getCookie("token");
            const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/v1/product-reviews/${productId}`, // Replace with your API endpoint

                reviewData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`, // Authorization token
                        "Content-Type": "application/json", // Specify content type as JSON
                    },
                }
            );
            return response.data; // Return the response data from the server (success message or data)
        } catch (error) {
            console.error("Error submitting review:", error);
            throw new Error("Failed to submit review. Please try again.");
        }
    };

    // Submit review
    const submitReview = async () => {
        if (!rating || !comment) {
            alert("Please provide both rating and comment.");
            return;
        }

        setIsSubmitting(true); // Set submitting state to true

        const reviewData = {
            rating,
            comment,
        };

        try {
            const response = await submitReviewAPI(reviewData); // Call the API function to submit the review
            toast.success("Review submitted successfully!"); // Handle success (you can show a success toast here)
            handleSubmit(response); // Pass the response to the parent component (optional)
            setRating(0); // Reset rating and comment after submission
            setComment("");
            handleClose(); // Close the modal
        } catch (error) {
            alert(error.message); // Handle error (you can show a toast error here)
        } finally {
            setIsSubmitting(false); // Set submitting state to false
        }
    };

    return (
        <>
        <Toaster position="top-right" reverseOrder={false}/>
         <div
            className={`modal fade ${show ? "show d-block" : ""}`}
            tabIndex="-1"
            aria-labelledby="reviewModalLabel"
            aria-hidden={!show}
        >
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="reviewModalLabel">
                            Write a Review
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={handleClose}
                        ></button>
                    </div>
                    <div className="modal-body">
                        <div className="mb-3">
                            <label className="form-label">Rate this product:</label>
                            <div>
                                {[1, 2, 3, 4, 5].map((star) => (
                                    <span
                                        key={star}
                                        className={
                                            star <= rating ? "text-warning fs-4" : "text-secondary fs-4"
                                        }
                                        style={{ cursor: "pointer" }}
                                        onClick={() => handleRating(star)}
                                    >
                                        ★
                                    </span>
                                ))}
                            </div>
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Your Review:</label>
                            <textarea
                                className="form-control"
                                rows="3"
                                placeholder="Write your thoughts here..."
                                value={comment}
                                onChange={(e) => setComment(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary rounded-pill px-3" onClick={handleClose}>
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="btn rounded-pill px-3"
                            style={{
                                background:'#371300',
                                color:'#FFFFFF',
                            }}
                            onClick={submitReview}
                            disabled={isSubmitting} // Disable button while submitting
                        >
                            {isSubmitting ? "Submitting..." : "Submit Review"}
                        </button>




                    </div>
                </div>
            </div>
        </div>
        </>
       
    );
};

export default ReviewModal;

